export default "/fonts/Museo500-Regular-webfont.woff2?092211cbc90c219e3a7bd1f01732a635";